import { Component, OnInit } from '@angular/core';
import { AjaxService } from 'src/app/service/ajax.service';
import { UtilService } from 'src/app/service/util.service';
import { API, BASE_API } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-adiciona-diario-etapa',
  templateUrl: './adiciona-diario-etapa.component.html',
  styleUrls: ['./adiciona-diario-etapa.component.scss']
})
export class AdicionaDiarioEtapaComponent implements OnInit {

  public BASE_API = BASE_API;
  public arrayDiarios: [];
  public arrayEtapas: [];
  public arrayEtapasDiario: any[];
  public habilitaAlterarDiario: boolean;

  public etapaSelecionado: any;
  public selectedRowIndexEtapa: number;

  // Propriedades para programas
  public arrayProgramas: any[];
  public programaSelecionado: any;

  constructor(private ajax: AjaxService, public util: UtilService) { }

  ngOnInit() {
    this.limpar();
    this.buscarProgramas();
    this.buscarDiarios();
    this.initStickyBehavior();
  }

  limpar(){
    this.habilitaAlterarDiario = false;
    this.arrayEtapasDiario = [];
  }

  buscarDiarioRelacionado(item){   
    this.limpar();
    this.util.showLoading();
    let url = API + "Diario/Diario/buscarDiarioEtapas?ID_ETAPA_PROGRAMA="+item.id;
    return this.ajax.get(url).subscribe(
      (response) => {
        console.log('Diário Relacionado',response.data);
        this.arrayEtapasDiario = response.data;
        this.util.closeLoading();
      },
      (err) => {
        debugger;
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Erro ao Buscar Diários");
      }
    );
  }

  selectDiario(item){
    console.log(item);
    Swal.fire({
      html: `Tem certeza adicionar o Diário <br><strong>${item.pergunta}</strong><br> a esta Etapa?`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Salvar',
      showLoaderOnConfirm: true
    }).then((result) => {
      debugger
      if (result.value != undefined && result.value != '') {
        this.adicionarDiarioRelacionamento(item);
      }
    });
  }

  adicionarDiarioRelacionamento(item){
    debugger
    let dados = {
      "ID_DIARIO": item.iD_DIARIO,
      "ID_ETAPA_PROGRAMA": this.etapaSelecionado.id
    }

    if(this.habilitaAlterarDiario)
        dados["ID_DIARIO_ETAPA_PROGRAMA"] = this.arrayEtapasDiario[0]["iD_DIARIO_ETAPA_PROGRAMA"];

    let url = API + "Diario/Diario/vincularDiarioEtapa";
    return this.ajax.post(url, dados)
    .subscribe(response  => {

      this.util.closeLoading();
      this.util.toasterShowSuccess("Atenção", "Salvo com Sucesso");      
      this.buscarDiarioRelacionado(this.etapaSelecionado);
      

    }, err => {
      debugger
      this.util.closeLoading();
      this.util.toasterShowError("Atenção", "Erro ao Salvar Escala");
    });
  }

  habilitaTableAlterar(){
    this.habilitaAlterarDiario = true;
  }

  selectEtapa(item){
    debugger
    this.selectedRowIndexEtapa = item.id;
    this.etapaSelecionado = item;
    this.buscarDiarioRelacionado(item);


    console.log('Array Diários',this.arrayDiarios);

    // Move o card diário para alinhar com o item selecionado
    setTimeout(() => {
      this.moveCardToSelectedItem();
    }, 300);
  }

  buscarEtapas() {
    this.limpar();
    
    if (!this.programaSelecionado) {
      this.arrayEtapas = [];
      this.etapaSelecionado = null;
      this.resetCardAlignment();
      return;
    }

    this.util.showLoading();
    let url = API + "ModuloPrograma/ModuloPrograma/ConsultarEtapaPrograma?ID_PROGRAMA=" + this.programaSelecionado;
    return this.ajax.get(url).subscribe(
      (response) => {
        console.log(response);
        this.arrayEtapas = response.data;
        this.util.closeLoading();
      },
      (err) => {
        debugger;
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Erro ao Buscar Etapas");
      }
    );
  }

  buscarDiarios() {
    this.limpar();
    this.util.showLoading();
    let url = API + "Diario/Diario/buscarDiario";
    return this.ajax.get(url).subscribe(
      (response) => {
        console.log(response);
        this.arrayDiarios = response.data;
        this.util.closeLoading();
      },
      (err) => {
        debugger;
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Erro ao Buscar Diários");
      }
    );
  }

  buscarProgramas() {
    this.util.showLoading();
    let url = API + "Programa/Programa";
    return this.ajax.get(url)
      .subscribe(response => {
        this.arrayProgramas = this.util.convertIoptions(response.data, "iD_PROGRAMA", "descricao");
        this.util.closeLoading();
      }, err => {
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Erro ao Buscar Programas");
      });
  }

  selecionarPrograma() {
    if (this.programaSelecionado) {
      this.resetCardAlignment(); // Reseta alinhamento quando novo programa é selecionado
      this.buscarEtapas();
    } else {
      this.arrayEtapas = [];
      this.etapaSelecionado = null;
      this.resetCardAlignment(); // Reseta alinhamento quando programa é desmarcado
    }
  }

  resetCardAlignment() {
    const card = document.getElementById('diarioCard');
    if (card) {
      card.style.position = '';
      card.style.top = '';
      card.classList.remove('is-sticky');
    }
  }

  initStickyBehavior() {
    // Aguarda um pouco para o DOM estar pronto
    setTimeout(() => {
      const card = document.getElementById('diarioCard');
      if (card) {
        window.addEventListener('scroll', () => {
          this.handleStickyBehavior(card);
        });
      }
    }, 100);
  }

  handleStickyBehavior(card: HTMLElement) {
    // Se o card está alinhado com um item, não faz nada
    if (card.classList.contains('aligned-with-item')) {
      return;
    }
    
    // Remove sticky se não há etapas ou não há item selecionado
    if (!this.arrayEtapas || this.arrayEtapas.length === 0 || !this.etapaSelecionado) {
      card.classList.remove('is-sticky');
      return;
    }
    
    // Só ativa o sticky se necessário
    const rect = card.getBoundingClientRect();
    const isSticky = rect.top <= 20;
    
    if (isSticky) {
      card.classList.add('is-sticky');
    } else {
      card.classList.remove('is-sticky');
    }
  }

  moveCardToSelectedItem() {
    const card = document.getElementById('diarioCard');
    const selectedRow = document.querySelector('tr.highlighted') as HTMLElement;
    
    if (!card || !selectedRow) return;
    
    // Posição da linha selecionada
    const rowTop = selectedRow.offsetTop;
    
    // Move o card para a mesma posição vertical
    card.style.position = 'relative';
    card.style.top = rowTop + 'px';
    
    console.log('Card movido para posição:', rowTop);
  }

}
